module.exports = __webpack_public_path__ + "static/img/cont604.0873483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont604.jpg
// module id = qmcj
// module chunks = 0